export const TEST = {
  UPDATE: "TOOLKIT_TEST_UPDATE",
  SAVING: "TOOLKIT_TEST_SAVING",
  LOADED: "TOOLKIT_TEST_LOADED",
  UPDATED: "TOOLKIT_TEST_UPDATED",
  CREATED: "TOOLKIT_TEST_CREATED",
  DELETED: "TOOLKIT_TEST_DELETED",
  LOADING: "TOOLKIT_TEST_LOADING",
  TASK_SAVING: "TOOLKIT_TASK_SAVING",
  UPDATE_TREE: "TOOLKIT_UPDATE_TREE",
  DUPLICATED: "TOOLKIT_TEST_DUPLICATED",
  SAVE_STATE: "TOOLKIT_TEST_SAVE_STATE",
};

export const SURVEY_LOAD = "TOOLKIT_SURVEY_LOAD";
export const SAVE_SURVEY_STATE = "TOOLKIT_SAVE_SURVEY_STATE";
export const SURVEY_ADD_QUESTION = "TOOLKIT_SURVEY_ADD_QUESTION";

export const REPORT_LOAD = "TOOLKIT_REPORT_LOAD";
export const REPORT_RESET = "TOOLKIT_REPORT_RESET";
export const REPORT_STALE = "TOOLKIT_REPORT_STALE";
export const REPORT_LOADING = "TOOLKIT_REPORT_LOADING";
export const REPORT_TEST_UPDATE = "TOOLKIT_REPORT_TEST_UPDATE";

export const STUDY = {
  LOAD: "TOOLKIT_LOAD",
  UPDATE: "TOOLKIT_UPDATE",
  COMPLETE: "TOOLKIT_COMPLETE",
  ATTEMPTED: "TOOLKIT_ATTEMPTED",
  MOVE_NEXT: "TOOLKIT_MOVE_NEXT",
  MOVE_PREV: "TOOLKIT_MOVE_PREV",
  SURVEY_LOAD: "TOOLKIT_SURVEY_INIT",
  SURVEY_SAVE: "TOOLKIT_SURVEY_SAVE",
  TASK_SAVING: "TOOLKIT_STYDY_TASK_SAVING",
  UPDATE_STATE: "TOOLKIT_STUDY_UPDATE_STATE",
};

export const TEST_ITEMS_KEYS = {
  CARDS: "TOOLKIT_cards",
  RECRUIT: "TOOLKIT_recruit",
  SETUP: "TOOLKIT_test-setup",
  MESSAGES: "TOOLKIT_messages",
  DETAILS: "TOOLKIT_test-details",
  CATEGORIES: "TOOLKIT_categories",
  QUESTIONNAIRE: "TOOLKIT_questionnaire",
};

export const NOTIFICATION = { SET: "TOOLKIT_NOTIFICATION_SET", REMOVE: "TOOLKIT_NOTIFICATION_REMOVE" };

export const SURVEY_TYPES = { SCREENER: "TOOLKIT_SCREENER", PRE_SURVEY: "TOOLKIT_PRE_SURVEY", POST_SURVEY: "TOOLKIT_POST_SURVEY" };

export const TEST_TAB_KEYS = { CREATE: "CREATE", RECRUIT: "RECRUIT", REPORT: "REPORT" };

export const STUDY_STEPS = {
  ERROR: "TOOLKIT_STUDY_STEPS_ERROR",
  TASKS: "TOOLKIT_STUDY_STEPS_TASKS",
  WELCOME: "TOOLKIT_STUDY_STEPS_WELCOME",
  SCREENER: "TOOLKIT_STUDY_STEPS_SCREENER",
  THANK_YOU: "TOOLKIT_STUDY_STEPS_THANK_YOU",
  PRE_SURVEY: "TOOLKIT_STUDY_STEPS_PRE_SURVEY",
  POST_SURVEY: "TOOLKIT_STUDY_STEPS_POST_SURVEY",
  DEMOGRAPHICS: "TOOLKIT_STUDY_STEPS_DEMOGRAPHICS",
  INSTRUCTIONS: "TOOLKIT_STUDY_STEPS_INSTRUCTIONS",
  SCRNEER_FAILED: "TOOLKIT_STUDY_STEPS_SCREENER_FAILED",
};
